(function () {
  'use strict';
  var originalFetch = window.fetch.bind(window);
  var forms = ['689a626e369d123b995a2b0d','66e32e56b864617c8e630139','67bf2c43927c938a9be269b5','6403a509653128bbaea27a4f'];
  window.fetch = function (input, options) {
    var url;
    try { url = new URL(typeof input === 'string' ? input : input.url, location.href); } catch (_) { return originalFetch(input, options); }
    if (url.origin === 'https://forms.soundestlink.com' && url.pathname === '/REST/forms/v1/renderedForms/6403a509653128bbaea27a4f' && location.pathname.indexOf('/apps/pk-contact-form/form/') === 0) {
      return originalFetch('https://purebreed.0088.co.uk/webhooks/storefront-secure/assets/breeder-form.json');
    }
    if (url.origin !== 'https://forms.soundestlink.com' || url.pathname !== '/REST/forms/v2/subscribe') return originalFetch(input, options);
    return (async function () {
      var request = new Request(input, options);
      if (request.method !== 'POST') return originalFetch(input, options);
      var payload = await request.json();
      // Fail closed for changed/unknown native forms instead of silently sending directly.
      if (forms.indexOf(payload.formID) === -1 || !window.pkFormSecurity) throw new Error('Security check unavailable. Please refresh and try again.');
      var form = document.getElementById('omnisend-form-' + payload.formID + '-step-' + payload.stepIndex + '-submit-form');
      if (!form) throw new Error('The form is not ready. Please refresh and try again.');
      var status = form.querySelector('.omnisend-form-' + payload.formID + '-submit-error');
      if (!status) throw new Error('The form is not ready. Please refresh and try again.');
      status.dataset.pkOmniSecurityStatus = '';
      status.setAttribute('role','alert');
      status.textContent = '';
      try {
        var token = await window.pkFormSecurity.token(form, 'omni_' + payload.formID);
        var response = await originalFetch('https://purebreed.0088.co.uk/webhooks/storefront-secure/omnisend', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ payload: payload, turnstileToken: token }), signal: request.signal
        });
        if (response.status === 429) throw new Error('Too many attempts. Please wait a moment and try again.');
        if (!response.ok) { var error = await response.json().catch(function () { return {}; }); throw new Error(error.message || 'We could not send the form. Please try again.'); }
        return response;
      } catch (error) { status.textContent = error.message || 'Please try the security check again.'; status.style.display = 'block'; throw error; }
    })();
  };
  // Keep the breeder application on the storefront so the same verification applies.
  var hosted = 'https://omniform1.com/forms/v1/landingPage/6377b4a600e4d27e263b56d1/6403a509653128bbaea27a4f';
  var local = '/apps/pk-contact-form/form/6377b4a600e4d27e263b56d1/6403a509653128bbaea27a4f';
  function links(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(function(a) { if (a.href.split('?')[0].split('#')[0] === hosted) a.setAttribute('href', local+a.search+a.hash); });
  }
  document.addEventListener('DOMContentLoaded', function () {
    links(document);
    new MutationObserver(function(records) { records.forEach(function(record) { record.addedNodes.forEach(function(node) { if(node.nodeType===1) { if(node.matches('a[href]')&&node.href.split('?')[0].split('#')[0]===hosted)node.setAttribute('href',local+node.search+node.hash);links(node); } }); }); }).observe(document.body,{childList:true,subtree:true});
  });
})();
